omadapp.singletons.factory = new(function() {
    var t = this;
    var $ = jQuery
    t.createComponent = createComponent
    t.createScene = createScene
    t.createSceneComponents = createSceneComponents
    t.prepararEscena = prepararEscena
    var dB = omadapp.singletons.domBuilder;

    function prepararEscena(obj,$page) {

        if (obj.builder.css) {
            trace (obj.builder.css.length)
            for (var i = obj.builder.css.length - 1; i >= 0; i--) {
                var srobj = obj.builder.css[i]
                trace (srobj.query)
                $page.find(srobj.query).each(function(index,o) {
                    var $o = $(o)
                    trace (o)
                    for (var n in srobj.css) {

                        var val = obtenerVal (srobj.css[n],$o)
                      
                        trace ("obj.builder.css")
                        trace (n+": "+val)
                        $o.css(n,val)
                    }
                })
            }
        }
        if (obj.builder.classes) {
            for (var i = obj.builder.classes.length - 1; i >= 0; i--) {
                var srobj = obj.builder.classes[i]
                $page.find(srobj.query).addClass(srobj.class)
            }
        }
        function obtenerVal (str,$el){
            var matcher = /\[([^\]]*)\]/g;
            trace ("factory::obtenerVal "+str)
            var ma = str.match(matcher)
            trace (ma)
            if (ma==null) return str;
            var res = str
            for (var i = 0; i < ma.length; i++) {
                var limpio = ma[i].replace(/(\[|\])/g,"")
                res = res.replace(ma[i],$el.attr(limpio))
            }
            trace (res)
            return res

        }
    }

    function newCall(Cls) {
        trace(arguments)
        var fact = Cls.bind.apply(Cls, arguments);
        return new fact();
    }

    function createComponent(id, arrayParams) {
        trace("factory::createComponent " + id)
        var cls = omadapp.components[id]
        return newCall(cls, arrayParams)
    }

    function createScene(obj, $page, game, callback) {
        new Creator(obj, $page, game, callback)
    }
    function createSceneComponents (escena,callback) {
        var obj = escena.datos
        var esperar = []
        escena.clases = {}
        trace("factory::generarClases")
        for (var n in obj.instances) {
            var cls = obj.instances[n]
            
            escena.clases[n] = createComponent(cls.type, cls.params)
            escena.clases[n].escena = escena
            if (cls.init) {
                escena.clases[n][cls.init]()
            }
            if (escena.clases[n].readyEvent) {
                addEspera(escena.clases[n])
            }
        }
        escena.clases.escena = escena
        if (obj.tiempoLimite&&obj.tiempoLimite>0) {
            escena.crearTemporizador.call(escena)
        }

        new Comprobador(esperar, function() {
            esperar = null
            escena.inicializar()
            callback(escena)
        })
        
        function addEspera(instancia) {
            esperar.push(instancia)
        }

    }

    function Comprobador(arr, callback) {
        var t = this

        var intervalo = setInterval(function() {
            var todas = true

            for (var i = arr.length - 1; i >= 0; i--) {
                //
                if (!arr[i].ready) {
                    trace (arr[i])
                    todas = false
                    i = -1
                }
            }
            //trace (".....")
            if (todas) {
                clearInterval(intervalo)
                setTimeout(function() {
                    arr = null
                    callback()
                },100)
            }
        }, 500)

    }

    function Creator(obj, $page, game, callback) {
        var t = this
       
        trace ("Creator::pasarTokens")
        trace (obj)
        obj = pasarTokens(obj,obj.id)
        trace("factory::Creator")
        trace(obj)
        trace (omadapp.controllers.scenes[obj.controller])
        trace(obj.controller)
        var escena = obj.controller ? new omadapp.controllers.scenes[obj.controller]($page,game) : new omadapp.controllers.scenes[obj.type + "Scene"]($page,game)
        escena.id = obj.id||obj.type
        escena.setData(obj)
        if (obj.builder) {
            dB.cargarTemplate(obj.builder.template,obj.builder.interface,obj.builder.temporizador, templateCargado)
        }
        function procesarToken (str,id) {
            return str.replace(/\*escena\*/g,".scene[data-sceneId='"+id+"']")
        }
        function pasarTokens (obj,id,indexacion,padre) {
            indexacion = indexacion||0
            padre = padre ||""
            if (obj==null) return 
            var esp = espacios(indexacion)
            if (typeof obj === "string") {
                return procesarToken (obj,id)
            } 


            if (typeof obj === 'object') {

               // trace (padre,100)

                for (var n in obj) {
                    if (n!="escena") {
                        obj[n] = pasarTokens(obj[n],id,indexacion+1,padre+" -> "+n)
                    }
                }

                return obj
            }

             return obj


        }
        function espacios (n) {
            var res=""
            for (var i = 0; i < n; i++) {
                res+=" "
            }
            return res
        }
        
        function templateCargado(temp) {

            $page.append(temp)
            trace ("factory::templateCargado")
            trace (obj.builder)
            $page.find("[src]").each(function(i,o) {
                var $o = $(o)
                if ( $o.attr("src")!="")$o.attr("src",omd_ctx($o.attr("src")))
            })
            if (obj.builder.sources) {
                for (var i = obj.builder.sources.length - 1; i >= 0; i--) {
                    var srobj = obj.builder.sources[i]
                    $page.find(srobj.query).each(function(index,o) {
                        var $o = $(o)
                        for (var n in srobj.attrs) {
                            $o.attr(n,srobj.attrs[n])
                        }
                    })
                }
            }
            trace (obj.builder.css)
            trace ("llega")
            omadapp.singletons.factory.prepararEscena(obj,$page)
            if (callback)callback(escena)
        }



    }

})